import { Application } from '../../models/application.model.js';
import { QUERY_PARAMS } from '../../constants/login.constants.js';
import { CookieService } from '../cookie/cookie.service.js';

class _AppService {
  constructor() {
    this.application = new Application();
    this.state = {};
  }

  getApplication() {
    return this.application;
  }

  setApplication(application) {
    this.application = application;
  }

  getState() {
    return this.state;
  }

  setState(state) {
    this.state = state ?? {};
  }

  setPromoCode(promoCode) {
    this.application.promoCode = promoCode;
  }

  getExternalId() {
    return this.state[QUERY_PARAMS.EXTERNAL_ID];
  }

  getSsoId() {
    return CookieService.getCookie('C1_CCID');
  }

  getPostSoftpullState() {
    return this.postSoftpullState;
  }

  setPostSoftpullState(postSoftpullState) {
    this.postSoftpullState = postSoftpullState;
  }

  setMockApplicationJoint() {
    this.application = {
      loanType: 'REFINANCE',
      applicationType: 'JOINT',
      profileType: 'financial',
      primaryApplicant: {
        lastName: 'Korey Lane',
        firstName: 'Korey Lane',
        emailAddress: 'john.doe@capitalone.com',
        confirmEmailAddress: '',
        phoneNumber: '606-568-2912',
        phoneType: 'mobile',
        smsOptIn: true,
        currentAddress: {
          street: '113 Pine Meadows',
          aptNumber: '',
          city: 'Dallas',
          stateCode: 'TX',
          zipCode: '75230',
          ownerStatus: 'OWN',
          monthlyPayment: 900,
        },
        currentAddressType: 'other',
        ssn: '123-45-6789',
        dateOfBirth: '06/11/1978',
        employmentStatus: 'employed',
        employmentInfo: {
          employerName: 'Capital One',
          yearsEmployed: null,
          monthsEmployed: null,
          jobDescription: 'Software Engineer',
          activeIncomeVerification: 'Yes',
        },
        incomeAmount: 90000,
        otherIncome: 0,
        prospectId: '',
        clientCorrelationId: '',
        isSameAddress: true,
        lastFourTaxId: '',
        maskedValue: '06/**/1978',
      },
      coApplicant: {
        lastName: 'Borrower',
        firstName: 'Co',
        emailAddress: 'a@a.com',
        confirmEmailAddress: 'a@a.com',
        phoneNumber: '555-314-3343',
        phoneType: 'MOBILE',
        smsOptIn: false,
        currentAddress: {
          street: '113 Pine Meadows',
          aptNumber: '',
          city: 'Dallas',
          stateCode: 'TX',
          zipCode: '75230',
          ownerStatus: 'OWN',
          monthlyPayment: 900,
        },
        currentAddressType: 'other',
        ssn: '111-11-1111',
        dateOfBirth: '12/01/2000',
        employmentStatus: 'unemployed',
        employmentInfo: {
          employerName: '',
          yearsEmployed: null,
          monthsEmployed: null,
          jobDescription: '',
          activeIncomeVerification: '',
        },
        incomeAmount: 1000,
        otherIncome: 0,
        profileReferenceId: '',
        prospectId: '',
        externalId: '',
        clientCorrelationId: '',
        isSameAddress: null,
        lastFourTaxId: '',
        maskedValue: '',
      },
      promoCode: '11491700',
      agreeToTerms: null,
      agreeToLookup: true,
      selectedVehicle: {
        make: 'Hyundai',
        model: 'Sonata',
        trim: 'ST',
        year: '2018',
        vin: '1HGEJ864XXL045226',
        wholeSaleValue: '18000.00',
        state: 'TX',
      },
      manualEntryFlag: false,
      selectedLoan: {
        lenderName: 'HNTINGTN NTL',
        currentBalance: 13000,
        remainingTerm: 28,
        lastPaymentDate: '2019-03-16',
        monthlyPayment: 500,
        apr: 8.35,
        isEligible: true,
        ineligibleReasons: [],
        openedDate: '2016-03-12',
        lenderAccountNumber: '2774822206',
        paymentDueDay: 15,
        isCapitalOneLoaned: 'no',
        isLease: '',
      },
      isNewApp: true,
      applicationReferenceId: '',
      isPrefilled: true,
      hasConsent: false,
      vehicleAndLoanMatchSelected: false,
      paymentDueDay: 15,
    };
  }
}

export const AppService = new _AppService();
